import type React from 'react';
import { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring, useReducedMotion } from 'framer-motion';

export interface ParallaxElementProps {
  children: React.ReactNode;
  speed?: number; // e.g., -0.2 (moves up faster), 0.2 (moves down slower)
  className?: string;
}

export function ParallaxElement({ children, speed = -0.15, className = '' }: ParallaxElementProps) {
  const ref = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  const rawY = useTransform(scrollYProgress, [0, 1], [100 * speed, -100 * speed]);
  const smoothY = useSpring(rawY, { damping: 25, stiffness: 150 });

  if (shouldReduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div ref={ref} className={`relative ${className}`}>
      <motion.div style={{ y: smoothY }} className="gpu-layer h-full w-full">
        {children}
      </motion.div>
    </div>
  );
}
